/**
 * Genera l'URL trasformato lato server da Supabase.
 * Documentazione: https://supabase.com/docs/guides/storage/serving/image-transformations
 */
export const getTransformedUrl = (
    baseUrl: string | null,
    type: 'banner' | 'gallery' | 'logo'
) => {
    if (!baseUrl) return '';

    // Convertiamo l'URL di base da object/public a render/image/public affinché Supabase Storage applichi le trasformazioni
    const renderUrl = baseUrl.replace('/object/public/', '/render/image/public/');

    const params = new URLSearchParams();

    if (type === 'banner') {
        params.append('width', '1200');
        params.append('height', '675'); // 16:9
        params.append('resize', 'cover');
    } else if (type === 'gallery') {
        params.append('width', '1000');
        params.append('height', '1000'); // Square
        params.append('resize', 'cover');
    } else if (type === 'logo') {
        params.append('width', '250');
        params.append('height', '250');
        params.append('resize', 'contain');
    }

    params.append('quality', '80');
    // params.append('format', 'webp');

    return `${renderUrl}?${params.toString()}`;
};